import { render, staticRenderFns } from "./SingleTagItem.vue?vue&type=template&id=4fd05258&scoped=true&"
import script from "./SingleTagItem.vue?vue&type=script&lang=js&"
export * from "./SingleTagItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleTagItem.vue?vue&type=style&index=0&id=4fd05258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd05258",
  null
  
)

export default component.exports